import { render, staticRenderFns } from "./UpdateOperator.vue?vue&type=template&id=2f84e9c1"
import script from "./UpdateOperator.vue?vue&type=script&lang=js"
export * from "./UpdateOperator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports